import { useSession } from '@/states/common';

const useBilling = () => {
  const { data: session } = useSession();

  const {
    team,
    sources,
    workspaces,
    additionalSources = 0,
    additionalUsers,
    subscriptionName,
    isAppSumoCustomer,
    isTenCodePurchaser,
  } = session?.billing ?? {
    team: 1,
    sources: 10,
    workspaces: 1,
    additionalSources: 0,
    additionalUsers: 0,
    isAppSumoCustomer: false,
    isTenCodePurchaser: false,
  };

  const plan = subscriptionName?.split('-')?.[0]?.toLowerCase();

  return {
    team,
    sources: sources + additionalSources,
    workspaces,
    members: additionalUsers,
    plan,
    subscription: subscriptionName,
    isAppSumoCustomer,
    isTenCodePurchaser,
  };
};

export default useBilling;
